import React from 'react';
import { Row, RowModel } from '@tanstack/react-table';
import { DataGridRow } from '../DataGridRow';

export type DataGridRowModelProps = {
  rowModel: RowModel<unknown>;
  renderSubComponent?: (props: { row: Row<any> }) => React.ReactElement;
  renderFootRow?: (row: Row<any>) => React.ReactElement;
  renderHeadRow?: (row: Row<any>) => React.ReactElement;
  headerStyle?: React.CSSProperties;
};
export const DataGridRowModel: React.FC<DataGridRowModelProps> = ({
  rowModel,
  renderSubComponent,
  renderFootRow,
  renderHeadRow,
  headerStyle,
}) => {
  return (
    <>
      {rowModel.rows.map((row) => (
        <React.Fragment key={row.id}>
          <DataGridRow
            row={row}
            renderSubComponent={renderSubComponent}
            renderFootRow={renderFootRow}
            renderHeadRow={renderHeadRow}
            headerStyle={headerStyle}
          />
        </React.Fragment>
      ))}
    </>
  );
};
